import { render, staticRenderFns } from "./GreenPremiseForm.vue?vue&type=template&id=fbc927f8&scoped=true&"
import script from "./GreenPremiseForm.vue?vue&type=script&lang=js&"
export * from "./GreenPremiseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc927f8",
  null
  
)

export default component.exports